module.exports = __webpack_public_path__ + "img/logo-mini.36924808.png";